<template>
  <div class="bg-platinumMild font-light w-full h-40 mb-6 py-4 flex flex-col justify-center items-center text-cosmosFire rounded-lg">
    <h2 v-show="canAddGroup" class="text-center w-7/12 mb-3 font-light text-sm">
        Looks like you’ve linked your FB account.
        You can now start adding groups.
    </h2>
    <h2 v-show="!canAddGroup" class="text-center w-7/12 mb-3 font-light text-sm">
        Looks like you’ve not linked your FB account.
        Once you link a new account you will be able to integrate groups.
    </h2>
    <button v-show="canAddGroup" class="flex items-center bg-aquamarine text-white rounded-lg px-8 py-3 mr-2" @click="$emit('addGroups')">
        <h2 class=" text-white mr-3 text-sm ">Add Groups</h2>
        <PlusIcon class="w-3"/>
    </button> 
  </div>
</template>

<script>
import PlusIcon from '@/components/svg/PlusIcon';
export default {
  name:"AddGroup",

  props: {
    canAddGroup: {
      type: Boolean,
      default: false,
    }
  },

  components: {
      PlusIcon,
  },
}
</script>

<style>

</style>